import { render, staticRenderFns } from "./ShareAutomationComponent.vue?vue&type=template&id=787b82f0&scoped=true"
import script from "./ShareAutomationComponent.vue?vue&type=script&lang=js"
export * from "./ShareAutomationComponent.vue?vue&type=script&lang=js"
import style0 from "./ShareAutomationComponent.vue?vue&type=style&index=0&id=787b82f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b82f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787b82f0')) {
      api.createRecord('787b82f0', component.options)
    } else {
      api.reload('787b82f0', component.options)
    }
    module.hot.accept("./ShareAutomationComponent.vue?vue&type=template&id=787b82f0&scoped=true", function () {
      api.rerender('787b82f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/ShareAutomationComponent.vue"
export default component.exports